import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import BasicInfo from './BasicInfo';
import AddressForm from './AddressForm';
import DocumentsUpload from './DocumentsUpload';
import OTPForm from './OTPForm';

import {
  initialValues,
  validationStep1,
  validationStep2,
  validationStep3
} from './shopRegisterValidation.js';
import useToast from '../../../API/GlobalHooks/useToast';
import { registerAccount } from '../../../API/Service/shopService';
import { useNavigate } from 'react-router-dom';
import { genOtp } from '../../../MIS/Global';
import { handleExist_user, handleWA_verify_sms } from './shopModel';

const ShopRegisterForm = () => {
  const navigate=useNavigate();
  const showToast = useToast();
  
  const [otp, setOtp] = useState(genOtp(4));
  const [verify, setVerify] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);

  const next = () => setStep((s) => s + 1);
  const prev = () => setStep((s) => s - 1);

   
  const handleSubmit = async (values) => {
    setLoading(true);
    const user_otp = values.user_otp || '';
    const resOtp = await handleWA_verify_sms({mob:values.mob,otp:user_otp})
    if(resOtp===false){
      // showToast("Invalid otp! Please try again", 'danger');
      alert('Invalid otp! Please try again');
      setLoading(false);
      return;
    }
    const shopName = values.shopName || '';
    const mob = values.mob || '';
    
    // Ensure we have at least 2 characters from shopName
    const password = `${shopName.substring(0, 2).toUpperCase()}@${mob}`;
  
    // Set the upaswd field to the generated password
    values.upaswd = password;
    const establishmentDate = values.establishmentDate ? values.establishmentDate : '1970-01-01';
    values.establishmentDate = establishmentDate;
    // Create FormData
    const formData = new FormData();
  
    // Append all scalar fields
    const scalarFields = [
      'shopName','shopType','ownerName','mob','establishmentDate',
      'emailid','website','address','city','state','postalCode',
      'country','user_otp','upaswd','user_status','user_role'
    ];
  
    scalarFields.forEach((field) => {
      // Only append non-null values
      if (values[field] !== undefined && values[field] !== null) {
        formData.append(field, values[field]);
      }
    });
  
    // Append file fields if present
    ['businessCertificate','gstCertificate','adharCard','utilityBill']
      .forEach((fileField) => {
        const file = values[fileField];
        if (file instanceof File) {
          formData.append(fileField, file);
        }
      });

     try {    
       const saveData= await registerAccount(formData);
      //  alert(JSON.stringify(saveData))
       if(saveData?.data==-1){        
        showToast(`User with mobile number ${mob} already exists.`, 'danger');
       }else if(saveData?.data?.id > 0){
        showToast("Account create successfully", 'success');
        navigate("/");
       }
     } catch (error) {
      showToast("Something went wrong during registration! Please try again", 'danger');
     }finally {
      setLoading(false); // Hide loader
    }


  };

  const getValidationSchema = () => {
    switch (step) {
      case 0:
        return validationStep1;
      case 1:
        return validationStep2;
      case 3:
        return validationStep3;
      default:
        return validationStep1;
    }
  };

  return (
    <div
      style={{
        maxWidth: '700px',
        margin: '2rem auto',
        padding: '2rem',
        border: '1px solid #ccc',
        borderRadius: '12px',
        backgroundColor: '#fdfdfd',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
        <h2 style={{ margin: '0', color: '#136E95' }}>Register</h2>
        <p
          tabIndex="0"
          style={{
            marginTop: '0.25rem',
            fontWeight: '500',
            color: '#444',
            outline: 'none',
          }}
        >
          Register only <span style={{ fontWeight: 'bold', color: '#136E95' }}>B2B</span>
        </p>
        <p
          style={{
            color: '#D24838',
            fontSize: '0.95rem',
            marginTop: '0.5rem',
            background: '#ffe9e7',
            padding: '0.75rem',
            borderRadius: '8px',
            lineHeight: '1.5',
          }}
        >
          Note: We do not disclose or sell any of your data to third parties.
          All documents submitted are strictly for verification purposes only.
        </p>
      </div>

      <h5 style={{ marginBottom: '1.2rem' }}>
        Step {step + 1} of 4: {['Basic Info', 'Address', 'Documents',"Verify & Create Account"][step]}
      </h5>

      <Formik
        initialValues={initialValues}
        validationSchema={getValidationSchema()}
        onSubmit={(values) => {
          if (step === 3) {
            handleSubmit(values);
          } else {
            if(step === 0){
              handleExist_user({mob:values?.mob,setVerifyLoading,setVerify,next})
            }
            else if (step === 2) {
              const docs = [
                values.businessCertificate,
                values.gstCertificate,
                values.adharCard,
                values.utilityBill,
              ];

              const uploadedCount = docs.filter((file) => file !== null).length;
                if (uploadedCount < 2) {
                  return;
                } else {
                  next();
                }
            }
            else{
            next();
            }
          }
        }}
      >
        {(formik) => (
          <Form>
            <div style={{ marginBottom: '1.5rem' }}>
              {step === 0 && <BasicInfo verify={verify} setVerify={setVerify} verifyLoading={verifyLoading}/>}
              {step === 1 && <AddressForm />}
              {step === 2 && (
                <>                  
                  <DocumentsUpload
                    values={formik.values}
                    setFieldValue={formik.setFieldValue}
                  />
                  
                </>
              )}
              {step === 3 && <OTPForm mob={formik.values.mob} otp={otp}/>}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {step > 0 && (
                <button
                  type="button"
                  onClick={prev}
                  style={{
                    padding: '0.5rem 1.25rem',
                    backgroundColor: '#ccc',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Back
                </button>
              )}
              
              <button
                type="submit"
                className="btn btn-primary d-flex align-items-center justify-content-center"
                style={{
                  padding: '0.5rem 1.25rem',
                  borderRadius: '5px',
                  minWidth: '100px',
                  opacity: loading ? 0.8 : 1,
                }}
                disabled={loading || verifyLoading}
              >
                {loading || verifyLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {loading?"Submitting...":"Validating number..."}
                  </>
                ) : (
                  step === 3 ? 'Submit' : 'Next'
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ShopRegisterForm;
